const React = require('react');

module.exports = ({title, className, children, reverse}) => {
  return (
    <div className={
      `p24 bgFAFAFA r9 bxsh2y2c0.25
      (bg2C2D30).reverse`
      + (className ? ` ${className}` : '')
      + (reverse ? ` reverse` : '')
    }>
      {title && (
        <div className="f16 lh24 fw7">
          {title}
        </div>
      )}
      <div>
        {children}
      </div>
    </div>
  )
}
